module.exports = __webpack_public_path__ + "static/media/results.e25e5123.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/results.svg
// module id = 106
// module chunks = 0